module.exports = __webpack_public_path__ + "img/benefit_behind-the-scenes-nfl.598a5c67.jpg";